// ** Icons Import
import { Icon } from '@iconify/react/dist/iconify.js';

export default [
    {
        id: 'expense',
        title: 'Expenses',
        icon: <Icon className='ic:outline-payments' />,
        navLink: '/expense'
    }
];
